import React, { Component } from 'react';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import ProjectsGraphQlController from '../../../controllers/projectsGraphQl';

import { gql } from '@apollo/client';
import _ from 'lodash';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
const getVendorEventsList = gql`
	query VendorEventsList($filters: VendorEventsListFiltersInput, $vendorId: String!) {
		vendorEventsList(filters: $filters) {
			data {
				id
				tenantId
				projectId
				name
				projectSlNo
				slNo
				category
				crew {
					count
					role
					managerIds
					subRole
					userIds
				}
				crewNew {
					userId
					roles {
						role
						subRole
					}
					isManager
					isCustomUser
				}
				city
				venue
				date
				time
				flagLabel
				reportingTime
				durationInHrs
				dateOverlap
				dateTimeOverlap
				parentEvent_id
				outStation
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
			isSuperHuemn
		}
	}
`;

class ShootsTenantsOverview extends ProjectsGraphQlController {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			page: 1,
			limit: 30,
			lengthOfList: 0,
			totalPages: 1,
			hasNextPage: true,
			columns: [
				// { title: 'FLAG' },
				{ title: 'DATE' },
				{ title: 'BRAND' },
				{ title: 'AM', subTitle: 'CP' },
				{ title: 'AM', subTitle: 'TP' },
				{ title: 'AM', subTitle: 'CV' },
				{ title: 'AM', subTitle: 'TV' },
				{ title: 'PM', subTitle: 'CP' },
				{ title: 'PM', subTitle: 'TP' },
				{ title: 'PM', subTitle: 'CV' },
				{ title: 'PM', subTitle: 'TV' },
				{ title: 'NO TIME', subTitle: 'CP' },
				{ title: 'NO TIME', subTitle: 'TP' },
				{ title: 'NO TIME', subTitle: 'CV' },
				{ title: 'NO TIME', subTitle: 'TV' },
			],
			shootsList: {},
		};
	}

	componentDidMount = () => {
		this.getVendorShootListData();
	};

	getVendorShootListData = async () => {
		let json = {
			filters: {
				page: this.state.page,
				limit: this.state.limit,
				sortType: 1,
				sortBy: 'date',
				subFilter: 'upcoming',
			},
			vendorId: 'HYD01',
		};

		this.getShootsCumulatedData(getVendorEventsList, json);
	};
	onClickNextPage = async () => {
		if (this.state.page < this.state.totalPages) {
			this.setState(
				{
					page: this.state.page + 1,
				},
				async () => {
					await this.fetchMoreShoots();
				},
			);
		}
	};
	fetchMoreShoots = async () => {
		let json = {
			filters: {
				page: this.state.page,
				limit: this.state.limit,
				sortType: 1,
				sortBy: 'date',
				subFilter: 'upcoming',
			},
			vendorId: 'HYD01',
		};

		this.getShootsCumulatedData(getVendorEventsList, json);
	};
	render() {
		return (
			<div className="layout-wrapper">
				{' '}
				{this.state.isLoading === true ? (
					<div className="container">
						<LoadingBar />
					</div>
				) : (
					<div className="container">
						<div className="searchContainer">
							<div className="shoots-header-filters-container"></div>
						</div>
						<div
							className={'table shoots-table'}
							id={'scrollableDiv-shoots-vendors'}
							style={{
								height: 'calc(90vh - 5px)',
								overflowY: 'auto',
								// marginTop: '-100px',
							}}
						>
							<div>
								<InfiniteScroll
									dataLength={this.state.lengthOfList}
									next={() => {
										this.onClickNextPage();
									}}
									hasMore={this.state.hasNextPage}
									loader={
										<div
											style={{
												color: '#fff',
												textAlign: 'center',
												width: '100%',
												padding: '20px',
											}}
										>
											Loading...
										</div>
									}
									scrollableTarget={'scrollableDiv-shoots-vendors'}
								>
									<table
										className="shootsTenantsTable"
										style={{ borderCollapse: 'collapse' }}
									>
										<thead
											style={{
												position: 'sticky',
												top: '0px',
												background: '#121212',
												/* make the table heads sticky */
											}}
										>
											<tr>
												<th colSpan={1} rowSpan={2}>
													Date
												</th>
												<th colSpan={1} rowSpan={2}>
													Brand
												</th>
												<th colSpan={1} rowSpan={2}>
													Shoot Count
												</th>
												<th colSpan={4}>AM</th>
												<th colSpan={4}>PM</th>
												<th colSpan={4}>NO Time</th>
											</tr>
											<tr>
												<td>CP </td>
												<td>TP </td>
												<td>CV </td>
												<td>TV </td>
												<td>CP </td>
												<td>TP </td>
												<td>CV </td>
												<td>TV </td>
												<td>CP </td>
												<td>TP </td>
												<td>CV </td>
												<td>TV </td>
											</tr>
										</thead>

										{_.map(this.state.shootsList, (shoot, key) => {
											return (
												<tr key={key}>
													<td>
														{moment(shoot.date, 'YYYYMMDD').format(
															'DD MMM YYYY',
														)}
													</td>
													<td>
														{
															_.filter(this.state.workspacesFilters, {
																key: shoot.tenantId,
															})[0]['name']
														}
													</td>
													<td>{shoot.shootsCount}</td>
													<td>
														{shoot.amShooterCount.candidPhoto === 0
															? ''
															: shoot.amShooterCount.candidPhoto}
													</td>
													<td>
														{shoot.amShooterCount.traditionalPhoto === 0
															? ''
															: shoot.amShooterCount.traditionalPhoto}
													</td>
													<td>
														{shoot.amShooterCount.candidVideo === 0
															? ''
															: shoot.amShooterCount.candidVideo}
													</td>
													<td>
														{shoot.amShooterCount.traditionalVideo === 0
															? ''
															: shoot.amShooterCount.traditionalVideo}
													</td>
													<td>
														{shoot.pmShooterCount.candidPhoto === 0
															? ''
															: shoot.pmShooterCount.candidPhoto}
													</td>
													<td>
														{shoot.pmShooterCount.traditionalPhoto === 0
															? ''
															: shoot.pmShooterCount.traditionalPhoto}
													</td>
													<td>
														{shoot.pmShooterCount.candidVideo === 0
															? ''
															: shoot.pmShooterCount.candidVideo}
													</td>
													<td>
														{shoot.pmShooterCount.traditionalVideo === 0
															? ''
															: shoot.pmShooterCount.traditionalVideo}
													</td>

													<td>
														{shoot.noTimeShooterCount.candidPhoto === 0
															? ''
															: shoot.noTimeShooterCount.candidPhoto}
													</td>
													<td>
														{shoot.noTimeShooterCount
															.traditionalPhoto === 0
															? ''
															: shoot.noTimeShooterCount
																	.traditionalPhoto}
													</td>
													<td>
														{shoot.noTimeShooterCount.candidVideo === 0
															? ''
															: shoot.noTimeShooterCount.candidVideo}
													</td>
													<td>
														{shoot.noTimeShooterCount
															.traditionalVideo === 0
															? ''
															: shoot.noTimeShooterCount
																	.traditionalVideo}
													</td>
												</tr>
											);
										})}
									</table>
								</InfiniteScroll>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default withRouter(ShootsTenantsOverview);
